'use client';

import { createFormHookContexts, createFormHook } from '@tanstack/react-form';
import { TextField } from '@/components/form-fields/text-field';
import { TextareaField } from '@/components/form-fields/textarea-field';
import { NumberField } from '@/components/form-fields/number-field';
import { CheckboxField } from '@/components/form-fields/checkbox-field';
import { RadioGroupField } from '@/components/form-fields/radio-group-field';
import { SubmitButton } from '@/components/form-fields/submit-button';

export const { fieldContext, useFieldContext, formContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    TextareaField,
    NumberField,
    CheckboxField,
    RadioGroupField,
  },
  formComponents: {
    SubmitButton,
  },
});
